import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { ConversationMessageAttachments } from './components/messageAttachments/conversationMessageAttachments';
/**
 * Represents the component for rendering textual media conversation message
 * events.
 */
export const ConversationTextualMediaMessageEvents = ({ events, hideAttachments, renderEventText, }) => {
    const getEventText = useCallback((event) => {
        return (_jsx(Box, Object.assign({ dir: "auto" }, { children: renderEventText ? renderEventText(event) : event.text })));
    }, [renderEventText]);
    const getEventAttachments = useCallback((event) => {
        return ('attached_files' in event &&
            event.attached_files &&
            !hideAttachments && (_jsx(ConversationMessageAttachments, { attachments: event.attached_files })));
    }, [hideAttachments]);
    return (_jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "200", style: { wordBreak: 'break-word' } }, { children: events.map((event) => (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "100" }, { children: [getEventText(event), getEventAttachments(event)] }), event.id))) })));
};
